// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"08492fb2","726":"2ae04808"}[chunkId] + ".chunk.js";
};